import { oneOf } from 'prop-types';

const period = oneOf([
  'day',
  'week',
  'month',
  'year',
  'first8weeks',
  'weeks52',
  'customDate',
]);

export default period;
